import {SLIDER_CONSTS} from "../constants";

export const initialState = {
    sliders: {
        HOME:[],
        BANNER:[]
    },
    sliderType: "HOME",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SLIDER_CONSTS.GET_SLIDERS:
            return {
                ...state,
                sliders: {
                    ...state.sliders,
                    [action.payload.type]: action.payload.data || [],
                }
            };
        case SLIDER_CONSTS.SET_SLIDER_TYPE:
            return {
                ...state,
                sliderType: action.payload
            };
        case SLIDER_CONSTS.DELETE_SLIDER_BY_ID:
            return {
                ...state,
                sliders: {
                    ...state.sliders,
                    [action.payload.type]: state.sliders[action.payload.type].filter(item => item.id !== action.payload.id)
                }
            };
        default:
            return state;
    }
}
